import { Pipe, PipeTransform } from '@angular/core';
import { isInteger } from 'lodash';

@Pipe({
  name: 'toFixedValue',
})
export class ToFixedValuePipe implements PipeTransform {
  transform(value: number, fractionDigits = 2, emptySymbol = null): string {
    if (isNaN(value)) {
      return emptySymbol;
    }
    return isInteger(value) ? `${value}` : value?.toFixed(fractionDigits);
  }
}
